export const mainLang = {
    js: {
        id:'JavaScript',
    },
    py: {
        id:'Python',
    },
    go: {
        id:'Go',
    },
    ts: {
        id:'TypeScript',
    },
    java: {
        id:'Java',
    },
}
